import React, {Component} from 'react';

export default class Attachments extends Component{

constructor(props)
{
  super(props);
  this.state={filename:"No file Chosen"};
  this.added=this.added.bind(this);
}

added()
{
    this.setState({filename:this.refs.toadd.value});
    if(this.refs.toadd.value=="")
    this.setState({filename:"No file Chosen"})
}
render()
{
  var st={

      blue:{
            borderRadius:"20px",
            backgroundColor:" #1a84eb",
            borderBottomRightRadius:0,
            borderBottomLeftRadius:0,
            height:"11.1px",

      },
      box:{
        borderRadius:"7px",
        borderTopRightRadius:0,
        borderTopLeftRadius:0,
        backgroundColor:"#ffffff",
        height:"200px",
        boxShadow: "0 3px 5px 0 rgba(0, 0, 0, 0.3)",
      },

      bttn_attri:{
        height:"56px",
        backgroundColor:"#1a84eb",
      },
      tex_:{
        fontSize:12,
        color: "#ffffff",
        letterSpacing: 0.3,
        height:"40px",
        backgroundColor:"#1a84eb",

      },
    };

  return(
    <div>
      <div className="img-rounded" style={st.blue}></div>
      <div className="panel panel-default" style={st.box}>
        <div className="panel-body">
          <br />
          <div className="row">
            <div className="col-md-1"></div>
            <h4 className="col-md-4 text-left text-uppercase"><strong>attachments</strong>
            </h4>
            <div className= "col-md-7"></div>
          </div>

          <br />

          <div className="row">
            <div className="col-md-1"></div>
            <div className="col-md-10">
              <label className="control-label">Select File</label>
              <input id="input-1a" type="file" className="file" data-show-preview="false" />
            </div>
            <div className="col-md-1"></div>

          </div>

        </div>
    </div>
</div>
  );

}
}



/** WEBPACK FOOTER **
 ** ./src/views/clientDashboard/Attachments.js
 **/